import { render, staticRenderFns } from "./Gewinn.vue?vue&type=template&id=5515492e&"
import script from "./Gewinn.vue?vue&type=script&lang=js&"
export * from "./Gewinn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports